var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_c('SdsPageHeader',{attrs:{"name":_vm.title,"hasUnderline":false,"breadcrumbs":_vm.breadcrumbs}}):_vm._e(),_c('LicencePreferencesContainer',{staticClass:"licence-preferences-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }